import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.map";
import _toConsumableArray from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.object.assign";
import { array } from 'vega-util';
import { isQuantitative } from '../../scale';
import { titlecase } from '../../util';
import { getStyleConfig } from '../common';

function getAxisConfigFromConfigTypes(configTypes, config) {
  // TODO: add special casing to add conditional value based on orient signal
  return Object.assign.apply(null, [{}].concat(_toConsumableArray(configTypes.map(function (configType) {
    return config[configType];
  }))));
}

export function getAxisConfigs(channel, scaleType, orient, config) {
  var typeBasedConfigTypes = scaleType === 'band' ? ['axisDiscrete', 'axisBand'] : scaleType === 'point' ? ['axisDiscrete', 'axisPoint'] : isQuantitative(scaleType) ? ['axisQuantitative'] : scaleType === 'time' || scaleType === 'utc' ? ['axisTemporal'] : [];
  var axisChannel = channel === 'x' ? 'axisX' : 'axisY';
  var axisOrient = 'axis' + titlecase(orient); // axisTop, axisBottom, ...

  var vlOnlyConfigTypes = [].concat(typeBasedConfigTypes, _toConsumableArray(typeBasedConfigTypes.map(function (c) {
    return axisChannel + c.substr(4);
  })));
  var vgConfigTypes = ['axis', axisOrient, axisChannel];
  return {
    vlOnlyAxisConfig: getAxisConfigFromConfigTypes(vlOnlyConfigTypes, config),
    vgAxisConfig: getAxisConfigFromConfigTypes(vgConfigTypes, config),
    axisConfigStyle: getAxisConfigStyle([].concat(vgConfigTypes, _toConsumableArray(vlOnlyConfigTypes)), config)
  };
}
export function getAxisConfigStyle(axisConfigTypes, config) {
  var _a;

  var toMerge = [{}];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = axisConfigTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var configType = _step.value;
      // TODO: add special casing to add conditional value based on orient signal
      var style = (_a = config[configType]) === null || _a === void 0 ? void 0 : _a.style;

      if (style) {
        style = array(style);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = style[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var s = _step2.value;
            toMerge.push(config.style[s]);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return Object.assign.apply(null, toMerge);
}
export function getAxisConfig(property, config, style) {
  var axisConfigs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _a;

  var styleConfig = getStyleConfig(property, style, config.style);

  if (styleConfig !== undefined) {
    return {
      configFrom: 'style',
      configValue: styleConfig
    };
  }

  for (var _i = 0, _arr = ['vlOnlyAxisConfig', 'vgAxisConfig', 'axisConfigStyle']; _i < _arr.length; _i++) {
    var configFrom = _arr[_i];

    if (((_a = axisConfigs[configFrom]) === null || _a === void 0 ? void 0 : _a[property]) !== undefined) {
      return {
        configFrom: configFrom,
        configValue: axisConfigs[configFrom][property]
      };
    }
  }

  return {};
}